module.exports = {
      id: "icon-home-plus-usage",
      viewBox: "0 0 27.193 24.672",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-home-plus",
      toString: function () {
        return this.url;
      }
    }